//
//
//
//
//
//
//
//
//
//

import { Fragment } from "vue-fragment";
import RichTextEditor from "@Shared/utils/rich-text-editor";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TextReadOnlyArgument",
  components: {
    Fragment
  },
  props: {
    text: {
      type: String,
      default: ""
    }
  },
  computed: {
    textHTML() {
      return RichTextEditor.sanitizeHtml(this.text);
    }
  }
});